import React, { Component } from 'react'
import Dashboard from '../../layouts/DashboardLayOut'
import MainDashboard from '../../components/Dashboard/MainDashboard'

export class MainDashboardPage extends Component {
  render() {
    return (
     <Dashboard>
        <MainDashboard/>
     </Dashboard>
    )
  }
}

export default MainDashboardPage